var _path, _rect, _g, _rect2, _circle, _path2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _path3, _circle2, _circle3, _circle4, _circle5, _path4, _path5, _path6, _g2, _path7, _g3, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _g4, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _rect10, _rect11, _rect12, _rect13, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTips1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 429,
    height: 399,
    viewBox: "0 0 429 399",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H402C416.912 0 429 12.0883 429 27V372C429 386.912 416.912 399 402 399H50C35.6406 399 24 387.359 24 373V0Z",
    fill: "#FFF5F5"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 283.05,
    width: 92,
    height: 87,
    rx: 11,
    transform: "rotate(-44.9964 31 283.05)",
    fill: "#FFEBEB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_3121)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 94,
    width: 333,
    height: 202,
    rx: 9,
    fill: "#EBF9FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67 186.25H364C367.728 186.25 370.75 189.272 370.75 193V295.75H60.25V193C60.25 189.272 63.2721 186.25 67 186.25Z",
    fill: "#F5FEFF",
    stroke: "#C6D5DD",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.25,
    y: 196.25,
    width: 310.5,
    height: 20.5,
    rx: 2.75,
    fill: "white",
    stroke: "#C6D5DD",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 81,
    cy: 206,
    r: 7,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 203,
    width: 6,
    height: 6,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91,
    y: 201,
    width: 55,
    height: 4,
    rx: 1,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151,
    y: 201,
    width: 8,
    height: 4,
    rx: 1,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166,
    y: 201,
    width: 30,
    height: 4,
    rx: 1,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203,
    y: 201,
    width: 43,
    height: 4,
    rx: 1,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 361,
    cy: 203,
    r: 1,
    fill: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 361,
    cy: 206,
    r: 1,
    fill: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 361,
    cy: 209,
    r: 1,
    fill: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.25,
    y: 217.25,
    width: 310.5,
    height: 20.5,
    rx: 2.75,
    fill: "white",
    stroke: "#C6D5DD",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 81,
    cy: 227,
    r: 7,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 224,
    width: 6,
    height: 6,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91,
    y: 222,
    width: 55,
    height: 4,
    rx: 1,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151,
    y: 222,
    width: 8,
    height: 4,
    rx: 1,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166,
    y: 222,
    width: 30,
    height: 4,
    rx: 1,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203,
    y: 222,
    width: 43,
    height: 4,
    rx: 1,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 361,
    cy: 224,
    r: 1,
    fill: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 361,
    cy: 227,
    r: 1,
    fill: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 361,
    cy: 230,
    r: 1,
    fill: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.25,
    y: 238.25,
    width: 310.5,
    height: 20.5,
    rx: 2.75,
    fill: "white",
    stroke: "#C6D5DD",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 81,
    cy: 248,
    r: 7,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 245,
    width: 6,
    height: 6,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91,
    y: 243,
    width: 55,
    height: 4,
    rx: 1,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151,
    y: 243,
    width: 8,
    height: 4,
    rx: 1,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166,
    y: 243,
    width: 30,
    height: 4,
    rx: 1,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203,
    y: 243,
    width: 43,
    height: 4,
    rx: 1,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 361,
    cy: 245,
    r: 1,
    fill: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 361,
    cy: 248,
    r: 1,
    fill: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 361,
    cy: 251,
    r: 1,
    fill: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.25,
    y: 259.25,
    width: 310.5,
    height: 20.5,
    rx: 2.75,
    fill: "white",
    stroke: "#C6D5DD",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 81,
    cy: 269,
    r: 7,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 266,
    width: 6,
    height: 6,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91,
    y: 264,
    width: 55,
    height: 4,
    rx: 1,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151,
    y: 264,
    width: 8,
    height: 4,
    rx: 1,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166,
    y: 264,
    width: 30,
    height: 4,
    rx: 1,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203,
    y: 264,
    width: 43,
    height: 4,
    rx: 1,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 361,
    cy: 266,
    r: 1,
    fill: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 361,
    cy: 269,
    r: 1,
    fill: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 361,
    cy: 272,
    r: 1,
    fill: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.25,
    y: 280.25,
    width: 310.5,
    height: 20.5,
    rx: 2.75,
    fill: "white",
    stroke: "#C6D5DD",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 81,
    cy: 290,
    r: 7,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 287,
    width: 6,
    height: 6,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91,
    y: 285,
    width: 55,
    height: 4,
    rx: 1,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151,
    y: 285,
    width: 8,
    height: 4,
    rx: 1,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166,
    y: 285,
    width: 30,
    height: 4,
    rx: 1,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203,
    y: 285,
    width: 43,
    height: 4,
    rx: 1,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 361,
    cy: 287,
    r: 1,
    fill: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 361,
    cy: 290,
    r: 1,
    fill: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 361,
    cy: 293,
    r: 1,
    fill: "#DEDEDE"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 49.25,
    y: 94.25,
    width: 332.5,
    height: 201.5,
    rx: 8.75,
    stroke: "#C6D5DD",
    strokeWidth: 0.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 79,
    r: 35,
    fill: "#FFEBEB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58 94.25H373C377.832 94.25 381.75 98.1675 381.75 103V113.75H49.25V103C49.25 98.1675 53.1675 94.25 58 94.25Z",
    fill: "white",
    stroke: "#C6D5DD",
    strokeWidth: 0.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 122.25,
    width: 96.5,
    height: 55.5,
    rx: 4.75,
    fill: "white",
    stroke: "#C6D5DD",
    strokeWidth: 0.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 107.25,
    y: 122.25,
    width: 163.5,
    height: 55.5,
    rx: 4.75,
    fill: "white",
    stroke: "#C6D5DD",
    strokeWidth: 0.5
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 281.25,
    y: 122.25,
    width: 113.5,
    height: 55.5,
    rx: 4.75,
    fill: "white",
    stroke: "#C6D5DD",
    strokeWidth: 0.5
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 75,
    width: 54,
    height: 13,
    rx: 6,
    fill: "#FFEBEB"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 109,
    y: 75,
    width: 54,
    height: 13,
    rx: 6,
    fill: "#FFEBEB"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 169,
    y: 75,
    width: 54,
    height: 13,
    rx: 6,
    fill: "#FFEBEB"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 98,
    y: 91,
    width: 54,
    height: 13,
    rx: 6,
    fill: "#FFEBEB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M118 155L143 164L168 143.5L209.5 159L254.5 134",
    stroke: "#F96652",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 119,
    cy: 155,
    r: 4,
    fill: "#F96652"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 168,
    cy: 143,
    r: 4,
    fill: "#F96652"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 210,
    cy: 159,
    r: 4,
    fill: "#F96652"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 253,
    cy: 134,
    r: 4,
    fill: "#F96652"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.136 145.788C31.576 146.34 32.68 147.132 33.448 148.164C34.216 149.196 34.6 150.432 34.6 151.872C34.6 153.384 34.192 154.704 33.376 155.832C32.56 156.936 31.396 157.788 29.884 158.388C28.372 158.988 26.596 159.288 24.556 159.288C22.54 159.288 20.776 158.988 19.264 158.388C17.776 157.788 16.624 156.936 15.808 155.832C14.992 154.704 14.584 153.384 14.584 151.872C14.584 150.432 14.956 149.196 15.7 148.164C16.468 147.132 17.572 146.34 19.012 145.788C17.86 145.236 16.984 144.504 16.384 143.592C15.784 142.68 15.484 141.6 15.484 140.352C15.484 138.96 15.856 137.748 16.6 136.716C17.368 135.684 18.436 134.892 19.804 134.34C21.172 133.788 22.756 133.512 24.556 133.512C26.38 133.512 27.976 133.788 29.344 134.34C30.736 134.892 31.804 135.684 32.548 136.716C33.316 137.748 33.7 138.96 33.7 140.352C33.7 141.576 33.388 142.656 32.764 143.592C32.164 144.504 31.288 145.236 30.136 145.788ZM24.556 136.428C22.852 136.428 21.508 136.8 20.524 137.544C19.54 138.264 19.048 139.248 19.048 140.496C19.048 141.744 19.528 142.728 20.488 143.448C21.472 144.168 22.828 144.528 24.556 144.528C26.308 144.528 27.676 144.168 28.66 143.448C29.668 142.728 30.172 141.744 30.172 140.496C30.172 139.248 29.656 138.264 28.624 137.544C27.616 136.8 26.26 136.428 24.556 136.428ZM24.556 156.372C26.548 156.372 28.12 155.964 29.272 155.148C30.424 154.308 31 153.18 31 151.764C31 150.372 30.424 149.28 29.272 148.488C28.12 147.672 26.548 147.264 24.556 147.264C22.564 147.264 21.004 147.672 19.876 148.488C18.748 149.28 18.184 150.372 18.184 151.764C18.184 153.18 18.748 154.308 19.876 155.148C21.004 155.964 22.564 156.372 24.556 156.372ZM48.768 143.7C50.424 143.7 51.9 144.012 53.196 144.636C54.516 145.26 55.548 146.16 56.292 147.336C57.036 148.488 57.408 149.82 57.408 151.332C57.408 152.916 57.012 154.308 56.22 155.508C55.452 156.708 54.384 157.644 53.016 158.316C51.672 158.964 50.16 159.288 48.48 159.288C45.096 159.288 42.48 158.196 40.632 156.012C38.808 153.828 37.896 150.732 37.896 146.724C37.896 143.916 38.388 141.528 39.372 139.56C40.38 137.568 41.772 136.068 43.548 135.06C45.348 134.028 47.436 133.512 49.812 133.512C51.036 133.512 52.188 133.644 53.268 133.908C54.348 134.148 55.284 134.508 56.076 134.988L54.708 137.796C53.508 137.004 51.9 136.608 49.884 136.608C47.268 136.608 45.216 137.424 43.728 139.056C42.24 140.664 41.496 143.016 41.496 146.112C41.496 146.496 41.508 146.796 41.532 147.012C42.252 145.932 43.236 145.116 44.484 144.564C45.756 143.988 47.184 143.7 48.768 143.7ZM48.336 156.372C49.992 156.372 51.336 155.928 52.368 155.04C53.4 154.152 53.916 152.964 53.916 151.476C53.916 149.988 53.388 148.812 52.332 147.948C51.3 147.06 49.908 146.616 48.156 146.616C47.028 146.616 46.02 146.832 45.132 147.264C44.268 147.696 43.584 148.284 43.08 149.028C42.6 149.772 42.36 150.6 42.36 151.512C42.36 152.4 42.588 153.216 43.044 153.96C43.524 154.68 44.208 155.268 45.096 155.724C46.008 156.156 47.088 156.372 48.336 156.372Z",
    fill: "#626262"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M361.5 169C372.27 169 381 160.27 381 149.5C381 138.73 372.27 130 361.5 130C350.73 130 342 138.73 342 149.5C342 160.27 350.73 169 361.5 169ZM361.5 158C366.194 158 370 154.194 370 149.5C370 144.806 366.194 141 361.5 141C356.806 141 353 144.806 353 149.5C353 154.194 356.806 158 361.5 158Z",
    fill: "#FFDA7C"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_3121",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 342,
    y: 130,
    width: 39,
    height: 39
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M361.5 169C372.27 169 381 160.27 381 149.5C381 138.73 372.27 130 361.5 130C350.73 130 342 138.73 342 149.5C342 160.27 350.73 169 361.5 169ZM361.5 158C366.194 158 370 154.194 370 149.5C370 144.806 366.194 141 361.5 141C356.806 141 353 144.806 353 149.5C353 154.194 356.806 158 361.5 158Z",
    fill: "#C4C4C4"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_3121)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M339.5 163L361.5 149L377 163L368.5 175.5L339.5 163Z",
    fill: "#97DD61"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1_3121",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 342,
    y: 130,
    width: 39,
    height: 39
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M361.5 169C372.27 169 381 160.27 381 149.5C381 138.73 372.27 130 361.5 130C350.73 130 342 138.73 342 149.5C342 160.27 350.73 169 361.5 169ZM361.5 158C366.194 158 370 154.194 370 149.5C370 144.806 366.194 141 361.5 141C356.806 141 353 144.806 353 149.5C353 154.194 356.806 158 361.5 158Z",
    fill: "#C4C4C4"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1_3121)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M350.5 126L361.5 149L379.5 165.5L386.5 160.5L379.5 128.5L350.5 126Z",
    fill: "#F27641"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M298.986 131.311H302.958V136.773H298.986V131.311Z",
    fill: "#F2F2F2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M298.241 131.311C297.419 131.311 297 131.923 297 132.677V135.408C297 136.162 297.419 136.773 298.241 136.773H298.986V131.311H298.241Z",
    fill: "#EC1C24"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M303.703 131.311H302.958V136.773H303.703C304.525 136.773 304.944 136.162 304.944 135.408V132.677C304.944 131.923 304.525 131.311 303.703 131.311Z",
    fill: "#EC1C24"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M302.494 133.998C302.437 133.972 302.427 133.954 302.444 133.891C302.486 133.734 302.53 133.578 302.572 133.422C302.576 133.409 302.579 133.396 302.584 133.377C302.531 133.388 302.482 133.397 302.433 133.408C302.334 133.429 302.235 133.45 302.136 133.471C302.071 133.485 302.041 133.467 302.023 133.403C302.006 133.342 301.989 133.281 301.961 133.212C301.955 133.222 301.95 133.234 301.942 133.243C301.828 133.372 301.714 133.499 301.6 133.628C301.564 133.667 301.525 133.684 301.497 133.668C301.456 133.645 301.458 133.604 301.465 133.566C301.495 133.4 301.526 133.234 301.557 133.067C301.58 132.946 301.603 132.826 301.626 132.7C301.614 132.705 301.606 132.707 301.599 132.711C301.535 132.744 301.471 132.778 301.407 132.81C301.328 132.85 301.288 132.837 301.247 132.76C301.16 132.599 301.073 132.437 300.986 132.275C300.982 132.267 300.979 132.259 300.972 132.249L300.958 132.275C300.871 132.437 300.784 132.599 300.697 132.76C300.656 132.837 300.616 132.85 300.537 132.81C300.472 132.778 300.409 132.744 300.345 132.711C300.338 132.707 300.33 132.705 300.318 132.7C300.341 132.826 300.364 132.946 300.387 133.067C300.418 133.233 300.449 133.399 300.479 133.566C300.486 133.604 300.487 133.645 300.446 133.668C300.418 133.684 300.379 133.667 300.344 133.628C300.23 133.499 300.115 133.372 300.002 133.243C299.994 133.234 299.989 133.222 299.983 133.212C299.955 133.281 299.938 133.342 299.921 133.403C299.903 133.467 299.873 133.485 299.808 133.471C299.709 133.45 299.61 133.429 299.511 133.408C299.461 133.397 299.412 133.388 299.36 133.377C299.365 133.396 299.368 133.409 299.371 133.422C299.414 133.578 299.457 133.734 299.499 133.891C299.516 133.954 299.507 133.972 299.45 133.998C299.397 134.021 299.345 134.047 299.29 134.073C299.3 134.081 299.305 134.087 299.311 134.092C299.443 134.199 299.575 134.307 299.708 134.414C299.836 134.518 299.963 134.622 300.091 134.726C300.136 134.762 300.151 134.806 300.132 134.86C300.122 134.893 300.113 134.925 300.103 134.957C300.091 134.996 300.08 135.034 300.067 135.077C300.194 135.059 300.314 135.043 300.435 135.026C300.576 135.006 300.718 134.986 300.86 134.969C300.908 134.962 300.945 134.999 300.943 135.048C300.932 135.304 300.907 135.593 300.905 135.835H301.038C301.037 135.593 301.012 135.304 301.001 135.048C300.999 134.999 301.035 134.962 301.084 134.969C301.226 134.986 301.367 135.006 301.509 135.026C301.63 135.043 301.75 135.06 301.877 135.077C301.864 135.034 301.852 134.996 301.841 134.957C301.831 134.925 301.822 134.893 301.811 134.86C301.793 134.806 301.808 134.762 301.852 134.726C301.981 134.622 302.108 134.518 302.236 134.414C302.368 134.307 302.5 134.199 302.632 134.092C302.639 134.087 302.644 134.081 302.654 134.073C302.598 134.046 302.546 134.021 302.494 133.998",
    fill: "#EC1C24"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M301.75 152.223H303.75C303.997 152.223 304.207 152.167 304.381 152.07L301.75 150.5V152.223Z",
    fill: "#2E3192"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M304.957 151.249C304.985 151.122 305 150.987 305 150.848V150.223H303.236L304.956 151.249",
    fill: "#2E3192"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M297.044 147.693C297.014 147.826 296.999 147.962 297 148.098V148.723H298.77L297.044 147.693Z",
    fill: "#2E3192"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M300.25 146.723H298.25C298.005 146.723 297.796 146.778 297.622 146.874L300.25 148.441V146.723Z",
    fill: "#2E3192"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M297.63 152.076C297.802 152.169 298.008 152.223 298.25 152.223H300.25V150.513L297.63 152.076Z",
    fill: "#2E3192"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M297 150.223V150.848C297 150.992 297.015 151.13 297.045 151.261L298.785 150.223H297Z",
    fill: "#2E3192"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M304.389 146.88C304.213 146.78 304 146.723 303.75 146.723H301.75V148.454L304.389 146.88V146.88Z",
    fill: "#2E3192"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M304.999 148.723V148.098C304.999 147.961 304.985 147.83 304.958 147.705L303.251 148.723H304.999Z",
    fill: "#2E3192"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M303.251 148.723L304.958 147.705C304.88 147.347 304.689 147.05 304.389 146.88L301.75 148.454V146.723H301.5V148.973H304.999V148.723H303.251Z",
    fill: "#E6E7E8"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M297 149.973V150.223H298.785L297.045 151.261C297.128 151.618 297.324 151.911 297.63 152.076L300.25 150.513V152.223H300.5V149.973H297Z",
    fill: "#E6E7E8"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M304.999 149.973H301.5V152.223H301.75V150.5L304.381 152.07C304.684 151.902 304.876 151.607 304.956 151.249L303.236 150.223H304.999V149.973Z",
    fill: "#E6E7E8"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M300.25 146.723V148.441L297.622 146.874C297.319 147.041 297.125 147.336 297.044 147.693L298.771 148.723H297V148.973H300.5V146.723H300.25Z",
    fill: "#E6E7E8"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M301.5 148.973V146.723H300.5V148.973H297V149.973H300.5V152.223H301.5V149.973H305V148.973H301.5Z",
    fill: "#BE1E2D"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M299.742 148.723L297.236 147.227C297.182 147.307 297.139 147.395 297.103 147.489L299.171 148.723H299.742",
    fill: "#BE1E2D"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M304.886 151.484L302.784 150.223H302.202L304.741 151.75C304.8 151.668 304.849 151.579 304.886 151.485",
    fill: "#BE1E2D"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M304.589 147.022L301.746 148.723L302.323 148.723L304.777 147.254C304.722 147.155 304.664 147.091 304.589 147.022Z",
    fill: "#BE1E2D"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M297.227 151.707C297.283 151.793 297.35 151.87 297.428 151.938L300.258 150.223H299.687L297.227 151.707Z",
    fill: "#BE1E2D"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1_3121)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M300.227 162.26V162.68H304.94C304.933 162.545 304.919 162.374 304.868 162.26",
    fill: "#EC1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.646 161.841H300.227V162.26H304.868C304.818 162.104 304.743 161.961 304.646 161.841",
    fill: "#E6E7E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.703 161.421H300.227V161.841H304.646C304.439 161.582 304.098 161.421 303.703 161.421Z",
    fill: "#EC1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.94 162.68H300.227V163.1H304.944V162.82C304.944 162.795 304.942 162.771 304.942 162.746C304.941 162.739 304.94 162.722 304.94 162.68",
    fill: "#E6E7E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.227 163.519H304.944V163.1H300.227V163.519Z",
    fill: "#EC1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.227 163.939H304.944V163.519H300.227V163.939",
    fill: "#E6E7E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.227 163.939H304.944V164.358H300.227V163.939Z",
    fill: "#EC1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297 164.358V164.778H304.944V164.358H300.227H297Z",
    fill: "#E6E7E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297 164.778H304.944V165.197H297V164.778Z",
    fill: "#EC1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.001 165.455C297.001 165.455 297 165.557 297.002 165.617H304.941C304.945 165.556 304.943 165.455 304.943 165.455L304.944 165.197H297L297.001 165.455Z",
    fill: "#E6E7E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.241 166.883H303.703C304.099 166.883 304.428 166.739 304.654 166.456H297.289C297.522 166.745 297.857 166.883 298.241 166.883",
    fill: "#EC1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.29 166.456H304.654C304.752 166.331 304.826 166.189 304.87 166.036H297.075C297.12 166.188 297.193 166.331 297.29 166.456",
    fill: "#E6E7E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.074 166.036H304.869C304.91 165.9 304.934 165.759 304.941 165.617H297.002C297.015 165.76 297.026 165.869 297.074 166.036Z",
    fill: "#EC1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.227 161.421H298.241C297.419 161.421 297 162.033 297 162.787V164.358H300.227V161.421Z",
    fill: "#176496"
  }))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M297.347 162.163L297.414 162.111L297.482 162.163L297.456 162.08L297.523 162.029H297.44L297.414 161.945L297.389 162.029H297.306L297.373 162.08L297.347 162.163Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M297.793 162.163L297.861 162.111L297.928 162.163L297.902 162.08L297.969 162.029H297.886L297.861 161.945L297.835 162.029H297.752L297.82 162.08L297.793 162.163Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M298.286 162.163L298.353 162.111L298.42 162.163L298.394 162.08L298.461 162.029H298.379L298.353 161.945L298.327 162.029H298.245L298.312 162.08L298.286 162.163Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M298.774 162.163L298.841 162.111L298.909 162.163L298.883 162.08L298.95 162.029H298.867L298.841 161.945L298.816 162.029H298.733L298.8 162.08L298.774 162.163Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M299.264 162.163L299.332 162.111L299.399 162.163L299.373 162.08L299.44 162.029H299.357L299.332 161.945L299.306 162.029H299.223L299.29 162.08L299.264 162.163Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M297.585 162.381L297.652 162.329L297.72 162.381L297.694 162.298L297.761 162.247H297.678L297.652 162.163L297.627 162.247H297.544L297.611 162.298L297.585 162.381Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M298.031 162.381L298.098 162.329L298.166 162.381L298.14 162.298L298.207 162.247H298.123L298.098 162.163L298.073 162.247H297.99L298.057 162.298L298.031 162.381Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M298.523 162.381L298.59 162.329L298.658 162.381L298.632 162.298L298.699 162.247H298.616L298.59 162.163L298.565 162.247H298.482L298.549 162.298L298.523 162.381Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M299.011 162.381L299.079 162.329L299.146 162.381L299.12 162.298L299.187 162.247H299.104L299.079 162.163L299.053 162.247H298.97L299.038 162.298L299.011 162.381Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M299.502 162.381L299.569 162.329L299.637 162.381L299.61 162.298L299.678 162.247H299.595L299.569 162.163L299.544 162.247H299.461L299.528 162.298L299.502 162.381Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M299.779 162.163L299.846 162.111L299.914 162.163L299.887 162.08L299.954 162.029H299.872L299.846 161.945L299.82 162.029H299.737L299.805 162.08L299.779 162.163Z",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M297.341 163.906L297.408 163.855L297.476 163.906L297.45 163.824L297.517 163.773L297.434 163.773L297.408 163.689L297.383 163.773L297.3 163.773L297.367 163.824L297.341 163.906Z",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M297.787 163.906L297.854 163.855L297.922 163.906L297.896 163.824L297.963 163.773L297.88 163.773L297.854 163.689L297.829 163.773L297.746 163.773L297.813 163.824L297.787 163.906Z",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M298.279 163.906L298.346 163.855L298.414 163.906L298.388 163.824L298.455 163.773L298.371 163.773L298.346 163.689L298.321 163.773L298.238 163.773L298.305 163.824L298.279 163.906Z",
    fill: "white"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M298.768 163.906L298.835 163.855L298.902 163.906L298.877 163.824L298.943 163.773L298.861 163.773L298.835 163.689L298.809 163.773L298.727 163.773L298.794 163.824L298.768 163.906Z",
    fill: "white"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M299.258 163.906L299.325 163.855L299.393 163.906L299.367 163.824L299.434 163.773L299.351 163.773L299.325 163.689L299.3 163.773L299.217 163.773L299.284 163.824L299.258 163.906Z",
    fill: "white"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M299.772 163.906L299.84 163.855L299.907 163.906L299.881 163.824L299.948 163.773L299.865 163.773L299.839 163.689L299.814 163.773L299.731 163.773L299.798 163.824L299.772 163.906Z",
    fill: "white"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M297.347 162.599L297.415 162.547L297.482 162.599L297.456 162.516L297.523 162.465L297.44 162.465L297.415 162.381L297.389 162.465L297.306 162.465L297.374 162.516L297.347 162.599Z",
    fill: "white"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M297.793 162.599L297.861 162.547L297.928 162.599L297.902 162.516L297.969 162.465L297.886 162.465L297.861 162.381L297.835 162.465L297.752 162.465L297.82 162.516L297.793 162.599Z",
    fill: "white"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M298.286 162.599L298.353 162.547L298.42 162.599L298.394 162.516L298.461 162.465L298.379 162.465L298.353 162.381L298.327 162.465L298.245 162.465L298.312 162.516L298.286 162.599Z",
    fill: "white"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M298.774 162.599L298.841 162.547L298.909 162.599L298.883 162.516L298.95 162.465L298.867 162.465L298.841 162.381L298.816 162.465L298.733 162.465L298.8 162.516L298.774 162.599Z",
    fill: "white"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M299.264 162.599L299.332 162.547L299.399 162.599L299.373 162.516L299.44 162.465L299.357 162.465L299.332 162.381L299.306 162.465L299.223 162.465L299.29 162.516L299.264 162.599Z",
    fill: "white"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M297.585 162.817L297.652 162.765L297.72 162.817L297.694 162.734L297.761 162.683H297.678L297.652 162.599L297.627 162.683H297.544L297.611 162.734L297.585 162.817Z",
    fill: "white"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M298.031 162.817L298.098 162.765L298.166 162.817L298.14 162.734L298.207 162.683H298.123L298.098 162.599L298.073 162.683H297.99L298.057 162.734L298.031 162.817Z",
    fill: "white"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M298.523 162.817L298.59 162.765L298.658 162.817L298.632 162.734L298.699 162.683H298.616L298.59 162.599L298.565 162.683H298.482L298.549 162.734L298.523 162.817Z",
    fill: "white"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M299.011 162.817L299.079 162.765L299.146 162.817L299.12 162.734L299.187 162.683H299.104L299.079 162.599L299.053 162.683H298.97L299.038 162.734L299.011 162.817Z",
    fill: "white"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M299.502 162.817L299.569 162.765L299.637 162.817L299.61 162.734L299.678 162.683H299.595L299.569 162.599L299.544 162.683H299.461L299.528 162.734L299.502 162.817Z",
    fill: "white"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M299.779 162.599L299.846 162.547L299.914 162.599L299.887 162.516L299.954 162.465L299.872 162.465L299.846 162.381L299.82 162.465L299.737 162.465L299.805 162.516L299.779 162.599Z",
    fill: "white"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M297.341 163.035L297.408 162.983L297.476 163.035L297.449 162.952L297.517 162.901L297.434 162.901L297.408 162.817L297.383 162.901L297.3 162.901L297.367 162.952L297.341 163.035Z",
    fill: "white"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M297.787 163.035L297.854 162.983L297.922 163.035L297.896 162.952L297.963 162.901L297.88 162.901L297.854 162.817L297.829 162.901L297.746 162.901L297.813 162.952L297.787 163.035Z",
    fill: "white"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M298.279 163.035L298.346 162.983L298.414 163.035L298.388 162.952L298.455 162.901L298.371 162.901L298.346 162.817L298.321 162.901L298.238 162.901L298.305 162.952L298.279 163.035Z",
    fill: "white"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M298.768 163.035L298.835 162.983L298.902 163.035L298.877 162.952L298.943 162.901L298.861 162.901L298.835 162.817L298.809 162.901L298.727 162.901L298.794 162.952L298.768 163.035Z",
    fill: "white"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M299.258 163.035L299.325 162.983L299.393 163.035L299.367 162.952L299.434 162.901L299.351 162.901L299.325 162.817L299.3 162.901L299.217 162.901L299.284 162.952L299.258 163.035Z",
    fill: "white"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M297.578 163.253L297.646 163.201L297.713 163.253L297.687 163.17L297.754 163.119H297.671L297.645 163.035L297.62 163.119H297.537L297.604 163.17L297.578 163.253Z",
    fill: "white"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M298.024 163.253L298.092 163.201L298.159 163.253L298.133 163.17L298.2 163.119H298.117L298.092 163.035L298.066 163.119H297.983L298.05 163.17L298.024 163.253Z",
    fill: "white"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M298.517 163.253L298.584 163.201L298.651 163.253L298.625 163.17L298.692 163.119H298.609L298.584 163.035L298.558 163.119H298.475L298.542 163.17L298.517 163.253Z",
    fill: "white"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M299.005 163.253L299.072 163.201L299.14 163.253L299.114 163.17L299.181 163.119H299.098L299.072 163.035L299.047 163.119H298.964L299.031 163.17L299.005 163.253Z",
    fill: "white"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M299.495 163.253L299.563 163.201L299.63 163.253L299.604 163.17L299.671 163.119H299.588L299.563 163.035L299.537 163.119H299.454L299.521 163.17L299.495 163.253Z",
    fill: "white"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M299.772 163.035L299.84 162.983L299.907 163.035L299.881 162.952L299.948 162.901L299.865 162.901L299.839 162.817L299.814 162.901L299.731 162.901L299.798 162.952L299.772 163.035Z",
    fill: "white"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M297.341 163.471L297.408 163.42L297.476 163.471L297.449 163.388L297.517 163.337L297.434 163.337L297.408 163.253L297.383 163.337L297.3 163.337L297.367 163.388L297.341 163.471Z",
    fill: "white"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M297.787 163.471L297.854 163.42L297.922 163.471L297.896 163.388L297.963 163.337L297.88 163.337L297.854 163.253L297.829 163.337L297.746 163.337L297.813 163.388L297.787 163.471Z",
    fill: "white"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M298.279 163.471L298.346 163.42L298.414 163.471L298.388 163.388L298.455 163.337L298.371 163.337L298.346 163.253L298.321 163.337L298.238 163.337L298.305 163.388L298.279 163.471Z",
    fill: "white"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M298.768 163.471L298.835 163.42L298.902 163.471L298.877 163.388L298.943 163.337L298.861 163.337L298.835 163.253L298.809 163.337L298.727 163.337L298.794 163.388L298.768 163.471Z",
    fill: "white"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M299.258 163.471L299.325 163.42L299.393 163.471L299.367 163.388L299.434 163.337L299.351 163.337L299.325 163.253L299.3 163.337L299.217 163.337L299.284 163.388L299.258 163.471Z",
    fill: "white"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M297.578 163.689L297.646 163.637L297.713 163.689L297.687 163.606L297.754 163.555H297.671L297.645 163.471L297.62 163.555H297.537L297.604 163.606L297.578 163.689Z",
    fill: "white"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M298.024 163.689L298.092 163.637L298.159 163.689L298.133 163.606L298.2 163.555H298.117L298.092 163.471L298.066 163.555H297.983L298.05 163.606L298.024 163.689Z",
    fill: "white"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M298.517 163.689L298.584 163.637L298.651 163.689L298.625 163.606L298.692 163.555H298.609L298.584 163.471L298.558 163.555H298.475L298.542 163.606L298.517 163.689Z",
    fill: "white"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M299.005 163.689L299.072 163.637L299.14 163.689L299.114 163.606L299.181 163.555H299.098L299.072 163.471L299.047 163.555H298.964L299.031 163.606L299.005 163.689Z",
    fill: "white"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M299.495 163.689L299.563 163.637L299.63 163.689L299.604 163.606L299.671 163.555H299.588L299.563 163.471L299.537 163.555H299.454L299.521 163.606L299.495 163.689Z",
    fill: "white"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M299.772 163.471L299.84 163.42L299.907 163.471L299.881 163.388L299.948 163.337L299.865 163.337L299.839 163.253L299.814 163.337L299.731 163.337L299.798 163.388L299.772 163.471Z",
    fill: "white"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 310,
    y: 130,
    width: 14,
    height: 9,
    rx: 2,
    fill: "#FFDA7C"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 310,
    y: 145,
    width: 14,
    height: 9,
    rx: 2,
    fill: "#F27641"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 310,
    y: 160,
    width: 14,
    height: 9,
    rx: 2,
    fill: "#97DD61"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 158,
    y: 91,
    width: 54,
    height: 13,
    rx: 6,
    fill: "#FFEBEB"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_3121"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 94,
    width: 333,
    height: 202,
    rx: 9,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1_3121"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.94393,
    height: 7.94393,
    fill: "white",
    transform: "translate(297 160.056)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTips1);
export default __webpack_public_path__ + "static/media/tips1.f00326d60de09d392743df6b0b5c5bec.svg";
export { ForwardRef as ReactComponent };